/* "Back to <collection>" on every product page (Craig 2026-10-16).
 * Collection grids link to the canonical /products/<handle> (an SEO decision, see product-grid-item),
 * so the product page cannot know server-side where the shopper came from. theme.liquid records the
 * last collection (or search) page in sessionStorage; we link back to it when this product is in it.
 * Otherwise the Liquid fallback (the product's main collection) is used, so the link ALWAYS shows.
 * Coming straight from that page, it behaves like the browser's Back button (same scroll position,
 * same filters). Once the inline link scrolls away, a round back button slides in on the left. */
(function () {
  var nav = document.querySelector('[data-sg-back]');
  if (!nav) return;
  var saved = null;
  try { saved = JSON.parse(sessionStorage.getItem('sg_back') || 'null'); } catch (e) {}
  var colls = (nav.getAttribute('data-colls') || '').split(',');
  var url, label;
  if (saved && saved.u && (saved.h === '*search' || colls.indexOf(saved.h) > -1)) {
    url = saved.u; label = saved.h === '*search' ? 'Back to search results' : 'Back to ' + saved.t;
  } else if (nav.getAttribute('data-ctx-url')) {
    url = nav.getAttribute('data-ctx-url'); label = 'Back to ' + nav.getAttribute('data-ctx-title');
  } else {
    url = nav.getAttribute('data-fb-url'); label = 'Back to ' + nav.getAttribute('data-fb-title');
  }
  if (!url) return;

  function go(e) {
    try {
      var r = document.referrer ? new URL(document.referrer) : null;
      var target = new URL(url, location.origin);
      if (r && r.origin === location.origin && r.pathname === target.pathname && history.length > 1) {
        e.preventDefault(); history.back(); return;
      }
    } catch (err) {}
    e.preventDefault(); location.href = url;
  }

  var a = nav.querySelector('a');
  a.href = url;
  nav.querySelector('[data-sg-back-label]').textContent = label;
  a.addEventListener('click', go);

  // floating round button, shown once the inline link has scrolled out of view
  var f = document.createElement('a');
  f.className = 'sg-back-float'; f.href = url; f.setAttribute('aria-label', label); f.title = label;
  f.innerHTML = a.querySelector('.sg-back__arrow').innerHTML;
  f.addEventListener('click', go);
  document.body.appendChild(f);
  function place() {
    // the bottom of whatever is pinned to the top of the screen (the sticky header), so the button sits just below it
    var b = 0, el = document.elementFromPoint(Math.round(window.innerWidth / 2), 4);
    while (el && el !== document.body) {
      var pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') b = Math.max(b, el.getBoundingClientRect().bottom);
      el = el.parentElement;
    }
    f.style.top = Math.max(12, Math.round(b) + 12) + 'px';
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      var off = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
      if (off) { place(); setTimeout(place, 350); }
      f.classList.toggle('is-on', off);
    }).observe(nav);
  }
  // the header only pins itself after the scroll starts, so re-measure while the button is showing
  var ticking = false;
  function onScroll() {
    if (ticking || !f.classList.contains('is-on')) return;
    ticking = true;
    requestAnimationFrame(function () { place(); ticking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', place, { passive: true });
})();
